import { last } from "lodash";
import { CLIENT_GET_ROOM_HISTORY } from "../../constants/methods";
import { PAGINATION_CLIENT_GET_ROOM_HISTORY } from "../../constants/pagination";
import { protoHandler } from "../../libs/proto";
import { ChatGetRoomResponse } from "../../proto/ChatGetRoom_pb";
import { ClientGetRoomResponse } from "../../proto/ClientGetRoom_pb";
import { ClientGetRoomHistory } from "../../proto/ClientGetRoomHistory_pb";
import store from "../../store";
import { addRoomMessages } from "../../store/messages/actions";
import { addRooms } from "../../store/rooms/actions";
import BaseHandler from "../BaseHandler";

export default class HandleClientGetRoomResponse extends BaseHandler<ClientGetRoomResponse | ChatGetRoomResponse> {
  handle() {
    const clientGetRoomResponse = this.response.toObject();

    if (clientGetRoomResponse.room !== undefined) {
      const message = clientGetRoomResponse.room.firstUnreadMessage || clientGetRoomResponse.room.lastMessage;
      store.dispatch(addRooms([clientGetRoomResponse.room]));

      if (message !== undefined) {
        store.dispatch(
          addRoomMessages({
            roomId: clientGetRoomResponse.room.id,
            messageList: [message],
          })
        );
      } else {
        protoHandler(CLIENT_GET_ROOM_HISTORY, {
          roomId: clientGetRoomResponse.room.id,
          direction: ClientGetRoomHistory.Direction.UP,
          limit: PAGINATION_CLIENT_GET_ROOM_HISTORY,
        }).then((clientGetRoomHistoryResponse) => {
          store.dispatch(
            addRooms([
              {
                ...clientGetRoomResponse.room!,
                lastMessage: last(clientGetRoomHistoryResponse.messageList),
              },
            ])
          );
        });
      }
    }
  }
}
